/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataAnalyticsActivitiesResponse } from '../models/data-analytics-activities-response';
import { EventOrganizer } from '../models/event-organizer';
import { ProfileResponse } from '../models/profile-response';
import { search } from '../fn/search/search';
import { Search$Params } from '../fn/search/search';
import { searchByTag } from '../fn/search/search-by-tag';
import { SearchByTag$Params } from '../fn/search/search-by-tag';
import { searchByTypeV2 } from '../fn/search/search-by-type-v-2';
import { SearchByTypeV2$Params } from '../fn/search/search-by-type-v-2';
import { searchOrganizer } from '../fn/search/search-organizer';
import { SearchOrganizer$Params } from '../fn/search/search-organizer';
import { searchProfile } from '../fn/search/search-profile';
import { SearchProfile$Params } from '../fn/search/search-profile';
import { SearchResponse } from '../models/search-response';
import { searchUser } from '../fn/search/search-user';
import { SearchUser$Params } from '../fn/search/search-user';
import { searchUserWithEmail } from '../fn/search/search-user-with-email';
import { SearchUserWithEmail$Params } from '../fn/search/search-user-with-email';
import { searchV2 } from '../fn/search/search-v-2';
import { SearchV2$Params } from '../fn/search/search-v-2';
import { UserTag } from '../models/user-tag';
import { UserTagWithEmail } from '../models/user-tag-with-email';

@Injectable({ providedIn: 'root' })
export class SearchService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `search()` */
  static readonly SearchPath = '/rest/search/{search}';

  /**
   * Search for entities in SH database - returned are users, profiles. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `search()` instead.
   *
   * This method doesn't expect any request body.
   */
  search$Response(params: Search$Params, context?: HttpContext): Observable<StrictHttpResponse<DataAnalyticsActivitiesResponse>> {
    return search(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for entities in SH database - returned are users, profiles. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `search$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  search(params: Search$Params, context?: HttpContext): Observable<DataAnalyticsActivitiesResponse> {
    return this.search$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataAnalyticsActivitiesResponse>): DataAnalyticsActivitiesResponse => r.body)
    );
  }

  /** Path part for operation `searchV2()` */
  static readonly SearchV2Path = '/rest/search-v2/{search}/{offset}/{limit}';

  /**
   * Search for entities in SH database - returned are profiles and activities. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2$Response(params: SearchV2$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchResponse>> {
    return searchV2(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for entities in SH database - returned are profiles and activities. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchV2(params: SearchV2$Params, context?: HttpContext): Observable<SearchResponse> {
    return this.searchV2$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchResponse>): SearchResponse => r.body)
    );
  }

  /** Path part for operation `searchByTypeV2()` */
  static readonly SearchByTypeV2Path = '/rest/search-v2/{search}/{offset}/{limit}/{searchBy}';

  /**
   * Search for entities in SH database - returned are profiles and activities, or just profile, or just activities. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchByTypeV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchByTypeV2$Response(params: SearchByTypeV2$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchResponse>> {
    return searchByTypeV2(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for entities in SH database - returned are profiles and activities, or just profile, or just activities. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchByTypeV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchByTypeV2(params: SearchByTypeV2$Params, context?: HttpContext): Observable<SearchResponse> {
    return this.searchByTypeV2$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchResponse>): SearchResponse => r.body)
    );
  }

  /** Path part for operation `searchByTag()` */
  static readonly SearchByTagPath = '/rest/search-by-tag/{search}/{offset}/{limit}';

  /**
   * Search for entities in SH database by tag - returned are profiles. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchByTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchByTag$Response(params: SearchByTag$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchResponse>> {
    return searchByTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for entities in SH database by tag - returned are profiles. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchByTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchByTag(params: SearchByTag$Params, context?: HttpContext): Observable<SearchResponse> {
    return this.searchByTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchResponse>): SearchResponse => r.body)
    );
  }

  /** Path part for operation `searchOrganizer()` */
  static readonly SearchOrganizerPath = '/rest/search-organizer/{search}';

  /**
   * Search for entities in SH database - returned are profiles, users. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchOrganizer()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchOrganizer$Response(params: SearchOrganizer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EventOrganizer>>> {
    return searchOrganizer(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for entities in SH database - returned are profiles, users. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchOrganizer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchOrganizer(params: SearchOrganizer$Params, context?: HttpContext): Observable<Array<EventOrganizer>> {
    return this.searchOrganizer$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EventOrganizer>>): Array<EventOrganizer> => r.body)
    );
  }

  /** Path part for operation `searchUser()` */
  static readonly SearchUserPath = '/rest/search-user/{search}';

  /**
   * Search for users in SH database. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchUser$Response(params: SearchUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTag>>> {
    return searchUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for users in SH database. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchUser(params: SearchUser$Params, context?: HttpContext): Observable<Array<UserTag>> {
    return this.searchUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserTag>>): Array<UserTag> => r.body)
    );
  }

  /** Path part for operation `searchUserWithEmail()` */
  static readonly SearchUserWithEmailPath = '/rest/admin/search-user';

  /**
   * Search for users in SH database with their email (only SH admin). Returned is max. 10 results. Search string is in request body.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchUserWithEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUserWithEmail$Response(params: SearchUserWithEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTagWithEmail>>> {
    return searchUserWithEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for users in SH database with their email (only SH admin). Returned is max. 10 results. Search string is in request body.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchUserWithEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchUserWithEmail(params: SearchUserWithEmail$Params, context?: HttpContext): Observable<Array<UserTagWithEmail>> {
    return this.searchUserWithEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserTagWithEmail>>): Array<UserTagWithEmail> => r.body)
    );
  }

  /** Path part for operation `searchProfile()` */
  static readonly SearchProfilePath = '/rest/search-profile';

  /**
   * Search for profile in SH. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchProfile$Response(params?: SearchProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
    return searchProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Search for profile in SH. Returned is max. 10 results (first found).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchProfile(params?: SearchProfile$Params, context?: HttpContext): Observable<Array<ProfileResponse>> {
    return this.searchProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileResponse>>): Array<ProfileResponse> => r.body)
    );
  }

}
